export class MissingStoreError extends Error {
	constructor() {
		super('Store is not initialized.');
		this.name = 'Missing Store Error';
	}
}
